/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core';
import { LandingFooter } from '../../common';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { iconslList } from '../../constants/menu';
import IconBox from '../../Sections/generator/page/IconBoxs/IconBox';
import { bgimage } from '../../Sections/constants';
import PageLayout from '../../Sections/shared/PageLayout';
import { roles } from '../../common/check';
import { useNavigate } from 'react-router-dom';
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { UpcomingTasksNotifications } from '../../components/UpcomingTasksNotifications';

export default function IconsLanding(props: any) {
  const { words, isRTL, user, theme, menuitem } = props;

  const { height } = useWindowDimensions();
  const navigate = useNavigate();
  const isManager = roles.isSuperAdmin() || roles.isBranchAdmin();

  return (
    <PageLayout
      menuitem={menuitem}
      isRTL={isRTL}
      words={words}
      user={user}
      theme={theme}
      bgimage={bgimage}
      refresh={null}
    >
      <Box
        style={{
          paddingLeft: 10,
          paddingRight: 10,
          height: height - 50,
          overflow: 'auto',
        }}
      >
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: 80,
          }}
        >
          <Typography variant="h4" style={{ fontWeight: 'bold' }}>
            السردال للضيافة
          </Typography>
        </Box>

        {/* Quick Access Cards */}
        <Grid
          container
          spacing={2}
          style={{ padding: '0 10px', marginBottom: 16 }}
        >
          {isManager && (
            <Grid item xs={6} md={3}>
              <Card
                style={{
                  backgroundColor: '#4caf50',
                  color: '#fff',
                  borderRadius: 12,
                }}
              >
                <CardActionArea onClick={() => navigate('/approvals')}>
                  <CardContent
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                      padding: 16,
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: 36 }} />
                    <Box>
                      <Typography style={{ fontWeight: 'bold', fontSize: 16 }}>
                        {isRTL ? 'الموافقات' : 'Approvals'}
                      </Typography>
                      <Typography variant="caption">
                        {isRTL
                          ? 'مراجعة الطلبات المعلقة'
                          : 'Review pending requests'}
                      </Typography>
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          )}
          <Grid item xs={6} md={3}>
            <Card
              style={{
                backgroundColor: '#f44336',
                color: '#fff',
                borderRadius: 12,
              }}
            >
              <CardActionArea onClick={() => navigate('/urgent')}>
                <CardContent
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                    padding: 16,
                  }}
                >
                  <WarningIcon style={{ fontSize: 36 }} />
                  <Box>
                    <Typography style={{ fontWeight: 'bold', fontSize: 16 }}>
                      {isRTL ? 'طلبات عاجلة' : 'Urgent Requests'}
                    </Typography>
                    <Typography variant="caption">
                      {isRTL ? 'عرض وإضافة الطلبات' : 'View & add requests'}
                    </Typography>
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={0}>
          {iconslList?.map((item: any) => {
            const { name, nameAr, icon, path, color, hide } = item;
            if (hide) return <></>;
            return (
              <Grid item xs={12} md={4} lg={3} key={item.id}>
                <IconBox
                  title={isRTL ? nameAr : name}
                  path={path}
                  icon={icon}
                  color={color}
                ></IconBox>
              </Grid>
            );
          })}
        </Grid>
        <LandingFooter></LandingFooter>
        <UpcomingTasksNotifications isRTL={isRTL} />
      </Box>
    </PageLayout>
  );
}
